import React from 'react';

const Header = ({ lastUpdated }) => {
  return (
    <header className="header">
      <h1>WeeklyDefense.com</h1>
      <h2>Summarizes Worldwide Military,WAR and Strategic Affairs</h2>
      {lastUpdated && (
        <p className="last-updated">
          Last Updated: {new Date(lastUpdated).toLocaleString()}
        </p>
      )}
    </header>
  );
};

export default Header;